export default function OurValues() {
  const values = [
    {
      icon: 'ri-drop-line',
      title: 'Purity First',
      subtitle: '순수함을 최우선으로',
      description: '자연이 만든 미네랄 밸런스를 그대로 유지하며, 불필요한 정제 과정을 거부합니다. 원수의 품질이 곧 제품의 품질입니다.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Sustainable Choice',
      subtitle: '지속 가능한 선택',
      description: '플라스틱 대신 100% 재활용 가능한 알루미늄 캔을 사용합니다. 깨끗한 물은 깨끗한 용기에서 완성됩니다.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparency',
      subtitle: '투명한 과정',
      description: '산지부터 소비자까지, 모든 과정을 투명하게 공개합니다. 과장 없는 정직함이 우리의 약속입니다.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Respect Nature',
      subtitle: '자연에 대한 존중',
      description: '유네스코 생물권보전지역의 자연을 보호하고, 지속 가능한 방식으로 물을 채취합니다.'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-teal-600 font-medium text-sm tracking-wider uppercase mb-4">Our Values</p>
          <h2 className="text-5xl lg:text-6xl font-light text-gray-900 mb-6">
            우리가 지키는 가치
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto">
            Heritage Water의 모든 결정은 이 네 가지 핵심 가치를 기반으로 합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl shadow-lg p-12 border border-gray-100 hover:shadow-2xl transition-all hover:-translate-y-2 duration-300"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-teal-50 rounded-full mb-6">
                <i className={`${value.icon} text-4xl text-teal-600`}></i>
              </div>
              <h3 className="text-2xl font-medium text-gray-900 mb-2">{value.title}</h3>
              <p className="text-sm text-teal-600 font-medium mb-4">{value.subtitle}</p>
              <p className="text-gray-600 font-light leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
